import { FC, memo, useCallback } from "react";
import { Button, FormHelperText, Stack } from "@mui/material";

const defaultWeekDays = [
  { key: 1, day: "S" },
  { key: 2, day: "M" },
  { key: 3, day: "T" },
  { key: 4, day: "W" },
  { key: 5, day: "T" },
  { key: 6, day: "F" },
  { key: 7, day: "S" },
];

interface WeekDaysProps {
  error?: string | string[] | boolean;
  color?: "success" | "warning" | "primary";
  weekDays: number[];
  onChange(days: number[]): void;
}

export const WeekDays: FC<WeekDaysProps> = memo(
  ({ weekDays, error, onChange, color }) => {
    const changeHandler = useCallback(
      (day: number) => () => {
        if (weekDays.includes(day)) {
          onChange(weekDays.filter((d) => d !== day));
        } else {
          onChange([...weekDays, day]);
        }
      },
      [onChange, weekDays],
    );

    return (
      <Stack>
        <Stack direction="row" alignItems="center">
          {defaultWeekDays.map((item, index) => (
            <Button
              color={color}
              key={item.key}
              sx={{
                mr: 1,
                borderRadius: "50%",
                minWidth: 40,
                width: 40,
                height: 40,
              }}
              variant={weekDays.includes(index + 1) ? "contained" : "outlined"}
              onClick={changeHandler(index + 1)}
            >
              {item.day}
            </Button>
          ))}
        </Stack>
        {error && (
          <FormHelperText error sx={{ mt: 1 }}>
            {error}
          </FormHelperText>
        )}
      </Stack>
    );
  },
);
